// libs
import { styled } from '@nykaa/ui-components';

// components
import ButtonBase from 'shared/components/Button';

export const Container = styled.div``;

export const Image = styled.img`
  display: block;
  margin: ${({ theme }) => `0 auto ${theme.spacing.spacing50}`};
  display: block;
`;

export const Title = styled.h5`
  text-align: center;
  ${({ theme }) => theme.typography.type201};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing80} 0`};
`;

export const Desc = styled.p`
  text-align: center;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: ${({ theme }) => `0 0 ${theme.spacing.spacing120} 0`};
`;

export const ActionCont = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PrimaryButton = styled(ButtonBase)`
  height: 48px;
  width: calc(55% - 4px);
  border-radius: ${({ theme }) => theme.borders.radius10};
  ${({ theme }) => theme.typography.subTitleLarge};
`;

export const SecondaryButton = styled(ButtonBase)`
  height: 48px;
  width: calc(45% - 4px);
  border-radius: ${({ theme }) => theme.borders.radius10};
  ${({ theme }) => theme.typography.subTitleLarge};
  background: #fff;
  color: ${({ theme }) => theme.colors.textSecondary};
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
`;
